import { memo as P, forwardRef as R, createElement as w, Children as N, isValidElement as W, cloneElement as b } from "react";
import { useComponentClassNames as E } from "../hooks/use-component-classnames.js";
import { composeRefs as O } from "../utils/compose-refs.js";
import { mergeProps as l } from "../utils/merge-props.js";
import { toKebabCase as j } from "../utils/misc.js";
function x(r) {
  let e = Object.getOwnPropertyDescriptor(r.props, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning;
  return t ? r.ref : (e = Object.getOwnPropertyDescriptor(r, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning, t ? r.props.ref : r.props.ref || r.ref);
}
const f = (r, e) => {
  const t = P(
    R((n, s) => {
      const { _id: i, className: m, children: d, ...u } = e, { asChild: g, children: h, ...y } = n, c = h || d, C = {
        className: E(i, m),
        "data-part": j(i)
      }, a = l(u, y, C);
      if (!g)
        return w(r, { ...a, ref: s }, c);
      const o = N.only(c);
      if (!W(o))
        return null;
      const p = x(o);
      return b(o, {
        ...l(a, o.props),
        ref: s ? O(s, p) : p
      });
    })
  );
  return t.displayName = r.displayName || r.name, t;
}, _ = () => new Proxy(f, {
  apply(r, e, t) {
    const n = t[0], s = t[1];
    return f(n, s);
  }
}), q = _();
export {
  q as ikp,
  _ as jsxFactory
};
